import SplitButton from "./SplitButton.vue";
import { pluginify } from "./../../util";
export default pluginify(SplitButton);
export { SplitButton };
